import { render } from "./UserControls.vue?vue&type=template&id=dd949a56"
import script from "./UserControls.vue?vue&type=script&lang=js"
export * from "./UserControls.vue?vue&type=script&lang=js"

import exportComponent from "/home/wsl-ubuntu/work-repos/ats-201-build-a-planet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__